import React from "react";
import { Stack, Container, Box, Typography, Link } from "@mui/material";
import { Login } from "../pages/login/LoginPage";

const LoginContainer = () => {
  return (
    <Box
      component="main"
      sx={{
        backgroundColor: "#FFFFFF",
        minHeight: "98vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        fontFamily: "SFProDisplay-Regular, Helvetica, Arial, sans-serif",
      }}
    >
      {/* Central Hero Section Wrap */}
      <Container
        maxWidth="lg"
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          py: { xs: 4, md: 8 },
        }}
      >
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={{ xs: 4, md: 8 }}
          sx={{
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* Left Hero Brand Context Box */}
          <Box sx={{ maxWidth: { md: 500 }, textAlign: { xs: "center", md: "left" } }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography
                variant="h1"
                sx={{
                  color: "#05305A",
                  fontWeight: "bold",
                  fontSize: { xs: "45px", md: "60px" },
                  letterSpacing: "-1px",
                  mb: 0,
                }}
              >
                Rent
              </Typography>

              <Typography
                variant="h1"
                sx={{
                  color: "#f1b828",
                  fontWeight: "bold",
                  fontSize: { xs: "45px", md: "60px" },
                  letterSpacing: "-1px",
                  mb: 0,
                }}
              >
                ly
              </Typography>
            </Box>
            <Typography
              variant="h5"
              sx={{
                color: "#1C1E21",
                fontSize: { xs: "20px", md: "24px" },
                lineHeight: "28px",
                fontWeight: "normal",
              }}
            >
              अब किरायेदारी हुई और भी आसान!
            </Typography>
          </Box>

          {/* Right Action Authentication Column */}
          <Box sx={{ width: "100%", maxWidth: "396px" }}>
            <Login />
          </Box>
        </Stack>
      </Container>

      {/* Footer Block */}
      <Box sx={{ bgcolor: "#ffffff", py: 3, borderTop: "1px solid #ddd" }}>
        <Container maxWidth="md">
          <Stack direction="row" flexWrap="wrap" gap={1.5} sx={{ color: "#737373", fontSize: "12px", mb: 1.5 }}>
            <Link href="#" color="inherit" underline="hover">English (UK)</Link>
            <Link href="#" color="inherit" underline="hover">हिन्दी</Link>
            <Link href="#" color="inherit" underline="hover">اردو</Link>
            <Link href="#" color="inherit" underline="hover">मराठी</Link>
          </Stack>
          <Box component="hr" sx={{ border: 0, borderTop: "1px solid #e5e5e5", my: 1 }} />
          <Typography variant="caption" sx={{ color: "#737373", fontSize: "12px" }}>
            Backbenchers: © {new Date().getFullYear()}
          </Typography>
        </Container>
      </Box>
    </Box>
  );
};

export default LoginContainer;